/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CorrectionDashboardItemRepositoryResponsePaginatedResponse } from "../types/CorrectionDashboardItemRepositoryResponsePaginatedResponse.ts";
import { correctionDashboardItemRepositoryResponseSchema } from "./correctionDashboardItemRepositoryResponseSchema.ts";

export const correctionDashboardItemRepositoryResponsePaginatedResponseSchema =
  z.object({
    data: z
      .array(z.lazy(() => correctionDashboardItemRepositoryResponseSchema))
      .nullish(),
    currentPage: z.optional(z.number().int()),
    totalPages: z.optional(z.number().int()),
    totalCount: z.optional(z.number().int()),
  }) as unknown as ToZod<CorrectionDashboardItemRepositoryResponsePaginatedResponse>;
